import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { iRootDispatch, iRootState } from '../../store';
import SectionLabel from '../../components/SectionLabel';
import { Button, TextArea, Form } from 'semantic-ui-react';
import styled from 'styled-components';
import { Formik } from 'formik';
import { createUser } from '../../services/user';
import { maskPhoneNumber, maskCpf } from '../../services/masks';
import {
  dangerNotification,
  successNotification,
  warningNotification
} from '../../services/notification';
import { FieldLabel } from '../../styles';
import { UserState } from '../../types/UserState';
import { UserRolesEnum } from '../../enums/user-roles.enum';
import { UserStatusEnum } from '../../enums/user-status.enum';
import * as Yup from 'yup';
// Importa o método customizado de validação de email sem acentos
import '../fire-insurance-budget-form/validators/constants';
import { useHistory } from 'react-router-dom';
import { BrokerForGetBrokerResponseDTO } from '../../dtos/broker/broker-for-get-broker-response.dto';
import { getBroker, getBrokerObjectFromGetBrokerDTO } from '../../services/broker';
import { BrokerState } from '../../types/BrokerState';
import { BrokersToCustomDropDownOptions } from '../../util';
import { AvailableBrokersAndEstatesState } from '../../store/types/temp-types';
import { useQueryClient } from '@tanstack/react-query';
import { isEstateRole } from '../../utils/isEstateRole';
import { getEstateUnits } from '../../services/estate-unit';
import { EstateUnitStatusEnum } from '../../types/EstateUnit';

const mapState = (state: iRootState) => ({
  availableBrokersAndEstates: state.availableBrokersAndEstates,
  user: state.user
});

const mapDispatch = (dispatch: iRootDispatch) => ({
  updateAvailableBrokersAndEstates: (availableBrokers: AvailableBrokersAndEstatesState) =>
    dispatch.availableBrokersAndEstates.updateAvailableBrokersAndEstates(availableBrokers)
});

type OptionsType = {
  value?: string;
  text: string;
  key: number;
};

const estateRoleOptions: OptionsType[] = [
  { key: 0, value: UserRolesEnum.estateAdmin, text: 'Administrador de Imobiliária' },
  { key: 1, value: UserRolesEnum.estateUser, text: 'Usuário de Imobiliária' },
  { key: 2, value: UserRolesEnum.estateQuotation, text: 'Cotação e consulta' }
];

const TextAreaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 5px;

  > textarea {
    background-color: #f5f8fa;
    width: 135%;
    border-radius: 4px;
    border: 1px solid rgba(34, 36, 38, 0.15);
    padding: 10px 4px;
    outline: 0;

    &:focus {
      border-color: #85b7d9;
    }
  }

  > label {
    // font-weight: bold;
    margin-bottom: 5px;
  }
`;

export type Props = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;

const UsersForm = (props: Props) => {
  const { role } = props.user;
  const isEstateUser = isEstateRole(role);
  const { availableBrokersAndEstates } = props;
  const [isLoading, setLoading] = useState<boolean>(false);
  const [isReady, setIsReady] = useState<boolean>(true);
  const [previousEstate, setPreviousEstate] = useState<string>('');
  const [previousFranchise, setPreviousFranchise] = useState<string>('');
  const [previousMasterFranchise, setPreviousMasterFranchise] = useState<string>('');
  const [options, setOptions] = useState<OptionsType[]>([]);
  const [statusOptions, setStatusOptions] = useState<OptionsType[]>([
    { key: 0, value: UserStatusEnum.active, text: 'Ativo' },
    { key: 1, value: UserStatusEnum.inactive, text: 'Inativo' },
    { key: 2, value: UserStatusEnum.pending, text: 'Pendente' }
  ]);

  const [userOptions, setUserOptions] = useState<OptionsType[]>([]);
  const [estateUnitOptions, setEstateUnitOptions] = useState<OptionsType[]>([]);
  const franchiseOptions = availableBrokersAndEstates.franchises;
  const masterFranchiseOptions = availableBrokersAndEstates.multiFranchises;
  const history = useHistory();

  const queryClient = useQueryClient();

  useEffect(() => {
    if (options.length === 0) {
      setLoading(true);
      const estates = availableBrokersAndEstates.estates.map(estate => {
        return {
          key: estate.key,
          text: estate.text,
          value: estate.value.id
        };
      });
      setUserOptions(availableBrokersAndEstates.roles);
      setOptions(estates);
      setLoading(false);
    }
  }, [
    availableBrokersAndEstates.estates,
    availableBrokersAndEstates.roles,
    options.length
  ]);

  const user: UserState = props.user;

  const create = async (payload: any) => {
    setLoading(true);

    if (
      (payload.estate === '' || payload.estate === null || payload.estate === undefined) &&
      (payload.scope === 'Imobiliária' || payload.scope === 'estate')
    ) {
      warningNotification('Oops...', 'Selecione a Imobiliária');
    } else if (!payload.role) {
      warningNotification('Oops...', 'Selecione o Tipo de Usuário');
    } else {
      if (payload.name && payload.email && payload.cellphone) {
        try {
          payload = {
            ...payload,
            user_id: user.id,
            estate: payload.estate || undefined,
            franchise: payload.franchise || undefined,
            multiFranchise: payload.multiFranchise || undefined,
            estateUnitId: payload.estateUnitId || null
          };

          delete payload.scope;

          await createUser(payload);

          queryClient.invalidateQueries({ queryKey: ['dropDownUsers'] });

          const brokerDTO: BrokerForGetBrokerResponseDTO = await getBroker(
            '7c98d9d9-a975-45a3-9131-cc1961250182'
          );
          const broker: BrokerState | null = brokerDTO
            ? getBrokerObjectFromGetBrokerDTO(brokerDTO)
            : null;

          props.updateAvailableBrokersAndEstates({
            ...props.availableBrokersAndEstates,
            brokers: BrokersToCustomDropDownOptions(true, broker ? [broker] : [])
          });

          successNotification(
            'Usuário cadastrado com sucesso!',
            'Um link para confirmação de cadastro foi enviado para o email informado'
          );

          history.push('/admin/users');
        } catch (error) {
          const { statusCode, message }: any = error;

          if (statusCode === 400) {
            warningNotification('Oops...', message);
          } else {
            dangerNotification(
              'Oops..',
              'Erro ao criar usuário, por favor, tente mais tarde.'
            );
          }
        }
      } else {
        if (!payload.email) {
          warningNotification('Oops...', 'O e-mail precisa ser preenchido');
          (document as any).querySelector('input[name="email"]').focus();
        }

        if (!payload.name) {
          warningNotification('Oops...', 'O nome precisa ser preenchido');
          (document as any).querySelector('input[name="name"]').focus();
        }

        if (!payload.cellphone) {
          warningNotification('Oops...', 'O celular precisa ser preenchido');
          (document as any).querySelector('input[name="cellphone"]').focus();
        }
      }
    }

    setLoading(false);
  };

  const activeEstateId =
    availableBrokersAndEstates?.activeEstateId ||
    user?.activeEstateId ||
    user?.estate?.id;

  const initialValuesUserForm = {
    name: '',
    email: '',
    role: user.role === UserRolesEnum.brokerAdmin ? UserRolesEnum.brokerAdmin : '',
    estate: user.role === UserRolesEnum.brokerAdmin ? '' : String(activeEstateId || ''),
    franchise:
      user.role !== UserRolesEnum.franchiseAdmin ? '' : String(user.franchise?.id),
    multiFranchise:
      user.role !== UserRolesEnum.multiFranchiseAdmin
        ? ''
        : String(user.multiFranchise?.id),
    doc: '',
    cellphone: '',
    status: UserStatusEnum.pending,
    observation: '',
    scope: user.role === UserRolesEnum.brokerAdmin ? 'Confiax' : 'estate',
    estateUnitId: ''
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Campo Obrigatório'),
    email: Yup.string().isValidEmailWithoutAccents().required('Campo Obrigatório'),
    role: Yup.string().required('Campo Obrigatório'),
    estate: Yup.string(),
    status: Yup.string(),
    cellphone: Yup.string()
      .matches(/^\([0-9]{2}\) [0-9]{4,5}-[0-9]{4}$/, 'Telefone inválido')
      .required('Campo Obrigatório'),
    doc: Yup.string().matches(/^[0-9]{3}.[0-9]{3}.[0-9]{3}-[0-9]{2}$/, 'CPF inválido'),
    observation: Yup.string()
  });

  return (
    <>
      {isReady /*&& options.length > 0*/ && (
        <Formik
          initialValues={initialValuesUserForm}
          validationSchema={validationSchema}
          onSubmit={() => {}}
        >
          {formikProps => (
            <UsersFormFields
              {...formikProps}
              role={role}
              isEstateUser={isEstateUser}
              isLoading={isLoading}
              options={options}
              userOptions={userOptions}
              statusOptions={statusOptions}
              estateUnitOptions={estateUnitOptions}
              setEstateUnitOptions={setEstateUnitOptions}
              franchiseOptions={franchiseOptions}
              masterFranchiseOptions={masterFranchiseOptions}
              previousEstate={previousEstate}
              setPreviousEstate={setPreviousEstate}
              previousFranchise={previousFranchise}
              setPreviousFranchise={setPreviousFranchise}
              previousMasterFranchise={previousMasterFranchise}
              setPreviousMasterFranchise={setPreviousMasterFranchise}
              create={create}
            />
          )}
        </Formik>
      )}
    </>
  );
};

type UserFormValues = {
  name: string;
  email: string;
  role: string;
  estate: string;
  franchise: string;
  multiFranchise: string;
  doc: string;
  cellphone: string;
  status: string;
  observation: string;
  scope: string;
  estateUnitId: string;
};

type UsersFormFieldsProps = {
  values: UserFormValues;
  setFieldValue: (field: string, value: unknown) => void;
  role: string;
  isEstateUser: boolean;
  isLoading: boolean;
  options: OptionsType[];
  userOptions: OptionsType[];
  statusOptions: OptionsType[];
  estateUnitOptions: OptionsType[];
  setEstateUnitOptions: React.Dispatch<React.SetStateAction<OptionsType[]>>;
  franchiseOptions: OptionsType[];
  masterFranchiseOptions: OptionsType[];
  previousEstate: string;
  setPreviousEstate: React.Dispatch<React.SetStateAction<string>>;
  previousFranchise: string;
  setPreviousFranchise: React.Dispatch<React.SetStateAction<string>>;
  previousMasterFranchise: string;
  setPreviousMasterFranchise: React.Dispatch<React.SetStateAction<string>>;
  create: (payload: Record<string, unknown>) => Promise<void>;
};

const UsersFormFields: React.FC<UsersFormFieldsProps> = ({
  values,
  setFieldValue,
  role,
  isEstateUser,
  isLoading,
  options,
  userOptions,
  statusOptions,
  estateUnitOptions,
  franchiseOptions,
  masterFranchiseOptions,
  previousEstate,
  setPreviousEstate,
  previousFranchise,
  setPreviousFranchise,
  previousMasterFranchise,
  setPreviousMasterFranchise,
  setEstateUnitOptions,
  create
}) => {
  useEffect(() => {
    const estateId = values.estate ? String(values.estate) : '';

    if (!estateId || !(values.scope === 'Imobiliária' || values.scope === 'estate')) {
      setEstateUnitOptions([]);
      setFieldValue('estateUnitId', '');
      return;
    }

    getEstateUnits({ estateId, status: EstateUnitStatusEnum.active })
      .then(units => {
        setEstateUnitOptions(
          (units || []).map((unit, index) => ({
            key: index,
            text: unit.name,
            value: unit.id
          }))
        );
      })
      .catch(() => setEstateUnitOptions([]));
  }, [values.estate, values.scope, setFieldValue, setEstateUnitOptions]);

  return (
    <Form>
              <SectionLabel text={'DADOS DO USUÁRIO'} />
              {(role === UserRolesEnum.brokerAdmin ||
                role === UserRolesEnum.brokerAnalyst ||
                role === UserRolesEnum.accountManager) && (
                <Form.Group>
                  <Form.Radio
                    name={'scope'}
                    label={'Corretora de Seguros RV'}
                    value={values.scope}
                    checked={values.scope === 'Confiax'}
                    onChange={(e, data) => {
                      setFieldValue('scope', 'Confiax');
                      setFieldValue('role', UserRolesEnum.brokerAnalyst);
                      setFieldValue('estate', null);
                      setFieldValue('franchise', null);
                      setFieldValue('multiFranchise', null);
                    }}
                  />

                  <Form.Radio
                    name={'scope'}
                    label={'Imobiliária'}
                    value={values.scope}
                    checked={values.scope === 'Imobiliária' || values.scope === undefined}
                    onChange={(e, data) => {
                      setFieldValue('scope', 'Imobiliária');
                      setFieldValue('role', UserRolesEnum.estateUser);
                      setFieldValue('estate', previousEstate);
                      setFieldValue('franchise', null);
                      setFieldValue('multiFranchise', null);
                    }}
                  />

                  <Form.Radio
                    name={'scope'}
                    label={'Franquia'}
                    value={values.scope}
                    checked={values.scope === 'Franquia' || values.scope === undefined}
                    onChange={(e, data) => {
                      setFieldValue('scope', 'Franquia');
                      setFieldValue('role', UserRolesEnum.franchiseAdmin);
                      setFieldValue('franchise', previousFranchise);
                      setFieldValue('estate', null);
                      setFieldValue('multiFranchise', null);
                    }}
                  />

                  <Form.Radio
                    name={'scope'}
                    label={'Multi Franquia'}
                    value={values.scope}
                    checked={
                      values.scope === 'Multi Franquia' || values.scope === undefined
                    }
                    onChange={(e, data) => {
                      setFieldValue('scope', 'Multi Franquia');
                      setFieldValue('role', UserRolesEnum.multiFranchiseAdmin);
                      setFieldValue('franchise', null);
                      setFieldValue('estate', null);
                      setFieldValue('multiFranchise', previousMasterFranchise);
                    }}
                  />
                </Form.Group>
              )}

              <Form.Group widths={'equal'}>
                {values.scope === 'Confiax' ? (
                  <Form.Select
                    name={'role'}
                    options={userOptions}
                    label={'Tipo de Usuário'}
                    loading={isLoading}
                    clearable={true}
                    value={values.role}
                    onChange={(e, data) => setFieldValue('role', data.value)}
                  />
                ) : values.scope === 'Imobiliária' || values.scope === 'estate' ? (
                  <>
                    <Form.Select
                      name={'estate'}
                      options={options}
                      disabled={isEstateUser || options.length === 1 || !!!options.length}
                      label={'Imobiliária'}
                      search
                      loading={isLoading || !!!options.length}
                      readonly={true}
                      clearable={true}
                      value={options.length === 1 ? options[0].value : values.estate}
                      onChange={(e, data) => {
                        setFieldValue('estate', data.value);
                        setFieldValue('estateUnitId', '');
                        setPreviousEstate(String(data.value));
                      }}
                    />
                    <Form.Select
                      name={'role'}
                      options={estateRoleOptions}
                      label={'Tipo de Usuário'}
                      value={values.role}
                      onChange={(e, data) => setFieldValue('role', data.value)}
                    />
                  </>
                ) : values.scope === 'Franquia' ? (
                  <Form.Select
                    name={'franchise'}
                    options={franchiseOptions}
                    disabled={franchiseOptions.length === 1 || !!!franchiseOptions.length}
                    label={'Franquia'}
                    search
                    loading={isLoading}
                    readonly={true}
                    clearable={true}
                    value={
                      franchiseOptions.length === 1
                        ? franchiseOptions[0].value
                        : values.franchise
                    }
                    onChange={(e, data) => {
                      setFieldValue('franchise', data.value);
                      setPreviousFranchise(String(data.value));
                    }}
                  />
                ) : (
                  <Form.Select
                    name={'multiFranchise'}
                    options={masterFranchiseOptions}
                    disabled={
                      masterFranchiseOptions.length === 1 ||
                      !!!masterFranchiseOptions.length
                    }
                    label={'Multi Franquia'}
                    search
                    loading={isLoading}
                    readonly={true}
                    clearable={true}
                    value={
                      masterFranchiseOptions.length === 1
                        ? masterFranchiseOptions[0].value
                        : values.multiFranchise
                    }
                    onChange={(e, data) => {
                      setFieldValue('multiFranchise', data.value);
                      setPreviousMasterFranchise(String(data.value));
                    }}
                  />
                )}

                <Form.Input
                  name={'name'}
                  autocomplete={'off'}
                  label={'Nome'}
                  value={values.name}
                  onChange={e => setFieldValue('name', e.target.value)}
                />

                <Form.Input
                  name={'email'}
                  label={'E-mail'}
                  readonly={true}
                  value={values.email}
                  onChange={e => setFieldValue('email', e.target?.value.trim())}
                />
              </Form.Group>

              <Form.Group widths={'equal'}>
                <Form.Input
                  name={'doc'}
                  label={'CPF'}
                  value={values.doc}
                  onChange={e => setFieldValue('doc', maskCpf(e.target.value))}
                />

                <Form.Input
                  name={'cellphone'}
                  label={'Celular'}
                  value={values.cellphone}
                  onChange={e =>
                    setFieldValue('cellphone', maskPhoneNumber(e.target.value))
                  }
                />

                <Form.Select
                  name={'status'}
                  options={statusOptions}
                  disabled={true}
                  label={'Status'}
                  loading={isLoading}
                  clearable={true}
                  value={
                    statusOptions.length === 1 ? statusOptions[0].value : values.status
                  }
                  onChange={(e, data) => setFieldValue('status', data.value)}
                />
              </Form.Group>

              {(values.scope === 'Imobiliária' || values.scope === 'estate') &&
                estateUnitOptions.length > 0 && (
                  <Form.Group widths={'equal'}>
                    <Form.Select
                      name="estateUnitId"
                      options={estateUnitOptions}
                      label="Unidade"
                      search
                      clearable
                      value={values.estateUnitId || ''}
                      onChange={(_, data) =>
                        setFieldValue('estateUnitId', data.value || '')
                      }
                    />
                  </Form.Group>
                )}

              <Form.Group widths={'equal'}>
                <TextAreaWrapper>
                  <FieldLabel>Observações</FieldLabel>
                  <TextArea
                    value={values.observation}
                    onChange={(e, data) => setFieldValue('observation', data.value)}
                  />
                </TextAreaWrapper>
              </Form.Group>

      <Button onClick={() => create(values)} color="green">
        Cadastrar
      </Button>
    </Form>
  );
};

export default connect(mapState, mapDispatch)(UsersForm);
